const NAMESPACE = 'COMMISSIONING_GA2';

export const ActionTypes = {
  SET_DEVICE: `${NAMESPACE}_SET_DEVICE`,
  SET_DEVICE_DATA: `${NAMESPACE}_SET_DEVICE_DATA`,
  SET_ACQ_INFO: `${NAMESPACE}_SET_ACQ_INFO`,
  SET_RASTER: `${NAMESPACE}_SET_RASTER`,
  SET_RASTER_STATUS: `${NAMESPACE}_SET_RASTER_STATUS`,
  SET_RASTER_DATA: `${NAMESPACE}_SET_RASTER_DATA`,
  SET_ANTENNA_DIRECTIONS: `${NAMESPACE}_SET_ANTENNA_DIRECTIONS`,
  SET_STEP: `${NAMESPACE}_SET_STEP`,
  SET_STEP_STATUS: `${NAMESPACE}_SET_STEP_STATUS`,
  SET_APPLY_ERROR: `${NAMESPACE}_SET_APPLY_ERROR`,
  CLEAR_APPLY_ERROR: `${NAMESPACE}_CLEAR_APPLY_ERROR`,
  SET_ERROR: `${NAMESPACE}_SET_ERROR`,
  SET_ARFCN_VALUES: `${NAMESPACE}_SET_ARFCN_VALUES`
};

export const GA2CommissioningSteps = {
  BEAM_SETTINGS: 1,
  ACQUISITION_INFO: 2,
  ACQUISITION_STATUS: 3,
  BEAM_SELECTION: 4,
  IN_SERVICE: 5
};

export const GA2CommissioningStepStatuses = {
  PRISTINE: 0,
  DIRTY: 1,
  PENDING: 2,
  FAILURE: 3,
  SUCCESS: 4
};

export const defaultAcqInfo = {
  polarization: 'horizontal',
  enableKpis: false
};
